export default __webpack_public_path__ + "static/media/video.5fabe6c1.mp4";